{
  "part_status": [
    {
      "value": "draft",
      "label": "Draft",
      "metadata": {}
    },
    {
      "value": "available",
      "label": "Available",
      "metadata": {}
    },
    {
      "value": "reserved",
      "label": "Reserved",
      "metadata": {}
    },
    {
      "value": "sold",
      "label": "Sold",
      "metadata": {}
    },
    {
      "value": "removed",
      "label": "Removed",
      "metadata": {}
    }
  ],
  "part_condition": [
    {
      "value": "new",
      "label": "New",
      "metadata": {}
    },
    {
      "value": "used_excellent",
      "label": "Used – Excellent",
      "metadata": {}
    },
    {
      "value": "used_good",
      "label": "Used – Good",
      "metadata": {}
    },
    {
      "value": "used_fair",
      "label": "Used – Fair",
      "metadata": {}
    },
    {
      "value": "for_parts",
      "label": "For Parts",
      "metadata": {}
    }
  ],
  "part_side": [
    {
      "value": "left",
      "label": "Left",
      "metadata": {}
    },
    {
      "value": "right",
      "label": "Right",
      "metadata": {}
    },
    {
      "value": "front",
      "label": "Front",
      "metadata": {}
    },
    {
      "value": "rear",
      "label": "Rear",
      "metadata": {}
    }
  ],
  "channel": [
    {
      "value": "own",
      "label": "Own site",
      "metadata": {}
    },
    {
      "value": "ebay",
      "label": "eBay",
      "metadata": {}
    },
    {
      "value": "facebook",
      "label": "Facebook",
      "metadata": {}
    },
    {
      "value": "craigslist",
      "label": "Craigslist",
      "metadata": {}
    },
    {
      "value": "carpart",
      "label": "Car-Part",
      "metadata": {}
    }
  ],
  "sale_status": [
    {
      "value": "completed",
      "label": "Completed",
      "metadata": {}
    },
    {
      "value": "returned",
      "label": "Returned",
      "metadata": {}
    },
    {
      "value": "voided",
      "label": "Voided",
      "metadata": {}
    }
  ],
  "cleanup_status": [
    {
      "value": "pending",
      "label": "Pending",
      "metadata": {}
    },
    {
      "value": "complete",
      "label": "Complete",
      "metadata": {}
    }
  ],
  "sale_channel": [
    {
      "value": "own",
      "label": "Own site",
      "metadata": {}
    },
    {
      "value": "ebay",
      "label": "eBay",
      "metadata": {}
    },
    {
      "value": "facebook",
      "label": "Facebook",
      "metadata": {}
    },
    {
      "value": "craigslist",
      "label": "Craigslist",
      "metadata": {}
    },
    {
      "value": "carpart",
      "label": "Car-Part",
      "metadata": {}
    },
    {
      "value": "other",
      "label": "Other",
      "metadata": {}
    }
  ],
  "carrier": [
    {
      "value": "usps",
      "label": "USPS",
      "metadata": {}
    },
    {
      "value": "ups",
      "label": "UPS",
      "metadata": {}
    },
    {
      "value": "fedex",
      "label": "FedEx",
      "metadata": {}
    },
    {
      "value": "dhl",
      "label": "DHL",
      "metadata": {}
    },
    {
      "value": "other",
      "label": "Other",
      "metadata": {}
    }
  ],
  "shipment_status": [
    {
      "value": "not_shipped",
      "label": "Not shipped",
      "metadata": {}
    },
    {
      "value": "shipped",
      "label": "Shipped",
      "metadata": {}
    },
    {
      "value": "delivered",
      "label": "Delivered",
      "metadata": {}
    },
    {
      "value": "returned",
      "label": "Returned",
      "metadata": {}
    }
  ],
  "membership_role": [
    {
      "value": "owner",
      "label": "Owner",
      "metadata": {}
    },
    {
      "value": "manager",
      "label": "Manager",
      "metadata": {}
    },
    {
      "value": "lister",
      "label": "Lister",
      "metadata": {}
    },
    {
      "value": "viewer",
      "label": "Viewer",
      "metadata": {}
    }
  ],
  "invitable_role": [
    {
      "value": "manager",
      "label": "Manager",
      "metadata": {}
    },
    {
      "value": "lister",
      "label": "Lister",
      "metadata": {}
    },
    {
      "value": "viewer",
      "label": "Viewer",
      "metadata": {}
    }
  ],
  "subscription_plan": [
    {
      "value": "trial",
      "label": "Trial",
      "metadata": {}
    },
    {
      "value": "starter",
      "label": "Starter",
      "metadata": {}
    },
    {
      "value": "shop",
      "label": "Shop",
      "metadata": {}
    },
    {
      "value": "pro",
      "label": "Pro",
      "metadata": {}
    }
  ],
  "seller_segment": [
    {
      "value": "part_out",
      "label": "Part out cars",
      "metadata": {}
    },
    {
      "value": "loose_parts",
      "label": "Sell loose parts",
      "metadata": {}
    }
  ],
  "membership_status": [
    {
      "value": "active",
      "label": "Active",
      "metadata": {}
    },
    {
      "value": "invited",
      "label": "Invited",
      "metadata": {}
    },
    {
      "value": "revoked",
      "label": "Revoked",
      "metadata": {}
    }
  ],
  "invitation_status": [
    {
      "value": "pending",
      "label": "Pending",
      "metadata": {}
    },
    {
      "value": "accepted",
      "label": "Accepted",
      "metadata": {}
    },
    {
      "value": "revoked",
      "label": "Revoked",
      "metadata": {}
    }
  ],
  "notification_event": [
    {
      "value": "risk_created",
      "label": "Double-sell risk",
      "metadata": {}
    },
    {
      "value": "invite_accepted",
      "label": "Invitation accepted",
      "metadata": {}
    },
    {
      "value": "sale_recorded",
      "label": "Sale recorded",
      "metadata": {}
    },
    {
      "value": "lead_created",
      "label": "New buyer inquiry",
      "metadata": {}
    },
    {
      "value": "lead_reply",
      "label": "New buyer reply",
      "metadata": {}
    },
    {
      "value": "weekly_summary",
      "label": "Weekly summary",
      "metadata": {}
    },
    {
      "value": "listing_health_digest",
      "label": "Listing health digest",
      "metadata": {}
    }
  ],
  "donor_status": [
    {
      "value": "active",
      "label": "Active",
      "metadata": {}
    },
    {
      "value": "fully_parted",
      "label": "Fully Parted",
      "metadata": {}
    },
    {
      "value": "archived",
      "label": "Archived",
      "metadata": {}
    }
  ]
}
